import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { KeyRound, CarFront, BadgeCheck, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    icon: KeyRound,
    title: "Short-Term Rentals",
    tag: "Days to weeks",
    image:
      "https://images.unsplash.com/photo-1652652432930-8f00d326e72b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjYXIlMjBkcml2aW5nJTIwc3Vuc2V0fGVufDB8fHx8MTc4NzQxNTk4OXww&ixlib=rb-4.1.0&q=85",
    points: [
      "No credit card needed — debit order & EFT accepted",
      "Verified ID & licence, refundable security deposit",
      "Routine maintenance and approved insurance/waiver included",
    ],
  },
  {
    icon: CarFront,
    title: "Rent-to-Own",
    tag: "Our flagship",
    image:
      "https://images.pexels.com/photos/8482859/pexels-photo-8482859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    points: [
      "Drive it home today — every payment builds ownership",
      "Defined 48 or 60-month path with monthly progress statements",
      "Income-led assessment for employed & self-employed applicants",
    ],
  },
  {
    icon: BadgeCheck,
    title: "Vehicle Sales",
    tag: "Own it outright",
    image:
      "https://images.unsplash.com/photo-1771284848859-12f150fa1637?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjYXIlMjBkZWFsZXJzaGlwJTIwaW5zaWRlfGVufDB8fHx8MTc4NzQxNTk4OXww&ixlib=rb-4.1.0&q=85",
    points: [
      "Immediate ownership at a clearly displayed price",
      "Inspected, roadworthy vehicles with full disclosures",
      "Fair prices, honest condition reports, no games",
    ],
  },
];

export default function Services() {
  return (
    <section data-testid="services-section" className="py-24 md:py-32 bg-[#0A1C45]">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">Three ways to drive</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white max-w-3xl mb-16">
            One trusted business. Every route to the road.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.1}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full bg-[#122659] border border-sky-300/20 rounded-xl overflow-hidden hover:border-[#F57C00]/50 transition-colors duration-300 flex flex-col"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#122659] via-[#0B1F4E]/30 to-transparent" />
                  <span className="absolute top-4 right-4 bg-[#0B1F4E]/80 backdrop-blur text-sky-300 text-[10px] uppercase tracking-widest font-bold px-3 py-1.5 rounded-full border border-sky-300/30">
                    {s.tag}
                  </span>
                </div>
                <div className="p-8 flex flex-col flex-1">
                  <s.icon size={28} className="text-[#F57C00] mb-5" />
                  <h3 className="font-display text-2xl font-bold text-white mb-4">{s.title}</h3>
                  <ul className="space-y-3 mb-8 flex-1">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-3 text-sm text-slate-400 leading-relaxed">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#F57C00] mt-2 shrink-0" />
                        {p}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={s.title === "Vehicle Sales" ? "/vehicles" : s.title === "Short-Term Rentals" ? "/rental" : "/pre-qualify"}
                    data-testid={`service-cta-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="inline-flex items-center gap-2 text-sm font-bold text-[#87CEEB] hover:text-white transition-colors"
                  >
                    {s.title === "Vehicle Sales" ? "Browse stock" : s.title === "Short-Term Rentals" ? "Book a rental" : "Check eligibility"}
                    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
